import { render, staticRenderFns } from "./quanbudingdandetail.vue?vue&type=template&id=7ae74284&scoped=true"
import script from "./quanbudingdandetail.vue?vue&type=script&lang=js"
export * from "./quanbudingdandetail.vue?vue&type=script&lang=js"
import style0 from "./quanbudingdandetail.vue?vue&type=style&index=0&id=7ae74284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae74284",
  null
  
)

export default component.exports